/**
 * Asynchronously loads the component for StudentResumeTemplates
 */

import { lazyLoad } from "utils/loadable";

export const StudentResumeTemplates = lazyLoad(
  () => import("./index"),
  (module) => module.StudentResumeTemplates
);
